export default "__VITE_ASSET__f78d4bde__"